import { createContext } from "react";

import type { Api } from "./api";

export const ApiContext = createContext<Api | null>(null);
